<template>
  <div class="company-top-100">
    <div class="title">
      <span>广东省民营百强企业</span>
      <ElementSelect :val="yearE" v-model="yearE" :options="eYearList"></ElementSelect>
    </div>
    <div class="chart-con">
      <div class="table-list">
        <div
                class="table-item"
                v-for="(item, i) in dataList"
                :key="i"
                @click="
            () => {
              showCompany = true;
              curData = item;
            }
          "
                @mouseenter="showTooltip(item, $event)"
                @mouseleave="hideTooltip"
        >
          <div class="left-con">
            <div :class="['num', 'top' + item.top, { top: item.top < 4 }]">{{ item.top }}</div>
            <div class="name">{{ item.companyName }}</div>
            <div class="city">{{ item.city }}</div>
          </div>
          <div class="right">
            <div class="border-box">{{ item.type }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 悬浮提示框 -->
    <div
            v-if="showTooltipFlag && currentTooltipItem"
            class="tooltip-box"
            :style="tooltipStyle"
    >
      <div class="tooltip-content">
        <div class="tooltip-title">企业信息</div>
        <div class="tooltip-row">
          <span class="tooltip-label">排名：</span>
          <span class="tooltip-value">{{ currentTooltipItem.top }}</span>
        </div>
        <div class="tooltip-row">
          <span class="tooltip-label">企业名称：</span>
          <span class="tooltip-value">{{ currentTooltipItem.companyName }}</span>
        </div>
        <div class="tooltip-row">
          <span class="tooltip-label">所属城市：</span>
          <span class="tooltip-value">{{ currentTooltipItem.city }}</span>
        </div>
        <div class="tooltip-row">
          <span class="tooltip-label">所属行业：</span>
          <span class="tooltip-value">{{ currentTooltipItem.type }}</span>
        </div>
        <div class="tooltip-row" v-if="currentTooltipItem.totalNum || currentTooltipItem.businessIncome">
          <span class="tooltip-label">营业收入(万元)：</span>
          <span class="tooltip-value">{{ formatTotalNum(currentTooltipItem.totalNum || currentTooltipItem.businessIncome) }}</span>
        </div>
      </div>
    </div>

    <EleDialog title="企业概况" :visible.sync="showCompany" class="company-profile">
      <CompModal v-if="showCompany" :curData="curData"></CompModal>
    </EleDialog>
  </div>
</template>

<script>
  import ElementSelect from '../../../components/element-select';
  import TabList from '../../../components/tabList';
  import ComTable from '../../../components/ComTable';
  import CompModal from './CompModal.vue';
  import { getTop100Data } from '@/api/getTableData';
  import $ from 'jquery';
  import drawPie3D from '../chartJs/pie3D';
  import echarts from 'echarts';

  export default {
    name: 'CompanyTop100',
    components: { ElementSelect, TabList, ComTable, CompModal },
    props: {
      yearP: {
        type: Number,
        default: 2023,
      },
      selectListP: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },
    data() {
      return {
        yearE: 0,
        eYearList: [],
        eYearOption: [],
        year: this.yearP,
        selectList: [...this.selectListP],
        dataList: [
          {
            top: 1,
            companyName: 'TCL(集团)',
            city: '惠州市',
            type: '计算机、通...',
          },
          {
            top: 2,
            companyName: '比亚迪股份有限公司',
            city: '深圳市',
            type: '汽车制造业',
          },
          {
            top: 3,
            companyName: '顺丰控股有限公司',
            city: '惠州市',
            type: '邮政业',
          },
          {
            top: 4,
            companyName: '广东鼎龙实业集团 ...',
            city: '惠州市',
            type: '商务服务业',
          },
          {
            top: 5,
            companyName: '广东鼎龙实业集团 ...',
            city: '惠州市',
            type: '商务服务业',
          },
          {
            top: 6,
            companyName: '广东鼎龙实业集团 ...',
            city: '惠州市',
            type: '商务服务业',
          },
        ],
        listBox: null,
        scrollY: 0,
        showCompany: false,
        curData: null,
        tabList: [
          {
            key: 0,
            label: '行政许可',
          },
          {
            key: 1,
            label: '迁移情况',
          },
          {
            key: 2,
            label: '变更情况',
          },
          {
            key: 3,
            label: '经营情况',
          },
          {
            key: 4,
            label: '经营异常情况',
          },
        ],
        tabIndex: 0,
        chart: null,
        chartOption: null,
        chartData: null,
        tableData: [],
        pager: {
          currentPage: 1,
          pageSize: 10,
          total: 22,
        },

        // 悬浮提示相关数据
        showTooltipFlag: false,
        currentTooltipItem: null,
        tooltipStyle: {
          top: '0px',
          left: '0px',
        },
      };
    },
    created() {
      this.initYear();
    },

    watch: {
      yearE(n) {
        this.getData();
      },
      chartData(n) {
        this.pager.total = n?.length ? Math.ceil((n?.length * 20) / this.legendBox.clientHeight) : 0;
      },
    },
    computed: {
      dialogUlList() {
        return [
          [
            {
              label: '法定代表人:',
              key: '',
            },
            {
              label: '企业类型:',
              key: '',
            },
            {
              label: '营业期限:',
              key: '',
            },
            {
              label: '中国民营企业500强排行:',
              key: '',
            },
            {
              label: '中国制造业民营企业500强排行:',
              key: '',
            },
          ],
          [
            {
              label: '统一社会信用代码:',
              key: '',
            },
            {
              label: '注册资本:',
              key: '',
            },
            {
              label: '所属地区:',
              key: '',
            },
            {
              label: '中国民营企业百强排行:',
              key: '',
            },
            {
              label: '是否为高新技术企业:',
              key: '',
            },
          ],
          [
            {
              label: '成立日期:',
              key: '',
            },
            {
              label: '实缴资本:',
              key: '',
            },
            {
              label: '注册地址:',
              key: '',
            },
            {
              label: '中国服务业民营企业500强排行:',
              key: '',
            },
            {
              label: '是否为小微企业:',
              key: '',
            },
          ],
        ];
      },
      tableCompCol() {
        let col = [];
        switch (this.tabIndex) {
          case 0:
            col = [
              {
                label: '许可文件编号',
                param: 'cityName',
              },
              {
                label: '许可文件名称',
                param: 'enterpriseName',
              },
              {
                label: '有效期',
                param: 'cityName',
              },
              {
                label: '许可机关',
                param: 'enterpriseName',
              },
              {
                label: '许可内容',
                param: 'cityName',
              },
            ];
            break;
          case 1:
            col = [
              {
                label: '迁入/迁出日期',
                param: 'ranking',
              },
              {
                label: '迁移原因',
                param: 'enterpriseName',
              },
              {
                label: '迁出地',
                param: 'industry',
              },
              {
                label: '迁入地',
                param: 'businessIncome',
              },
              {
                label: '迁出登地登记机关',
                param: 'enterpriseName',
              },
              {
                label: '迁入地登记机关',
                param: 'industry',
              },
              {
                label: '更新时间',
                param: 'businessIncome',
              },
            ];
            break;
          case 2:
            col = [
              {
                label: '变更日期',
                param: 'ranking',
              },
              {
                label: '变更事项',
                param: 'enterpriseName',
              },
              {
                label: '变更前内容',
                param: 'industry',
              },
              {
                label: '变更后内容',
                param: 'businessIncome',
              },
              {
                label: '变更登记机关',
                param: 'enterpriseName',
              },
            ];
            break;
          case 3:
            col = [
              {
                label: '年份',
                param: 'ranking',
              },
              {
                label: '营收总额（万元）',
                param: 'enterpriseName',
              },
            ];
            break;
          case 4:
            col = [
              {
                label: '列入日期',
                param: 'ranking',
              },
              {
                label: '列入经营异常原因类型',
                param: 'enterpriseName',
              },
              {
                label: '列入决定机关',
                param: 'industry',
              },
              {
                label: '是否移出',
                param: 'businessIncome',
              },
              {
                label: '移出经营异常原因类型',
                param: 'enterpriseName',
              },
              {
                label: '移出日期',
                param: 'businessIncome',
              },
              {
                label: '移出决定机关',
                param: 'enterpriseName',
              },
            ];
            break;
          default:
            break;
        }
        return col;
      },
    },
    methods: {
      initYear(){
        this.$api.market.getTyYearOption({dataType: 'tj_provinces_top_100_private_enterprises'}).then((res) => {
          this.eYearOption = res.data.data.data;
          if (this.yearE === 0) {
            this.yearE = this.eYearOption[0];
            this.eYearList = []
            for (let key in this.eYearOption) {
              this.eYearList.push(
                      {
                        value: this.eYearOption[key],
                        lable: this.eYearOption[key],
                      }
              );
            }
          }
        });
      },

      // 显示悬浮提示
      showTooltip(item, event) {
        this.currentTooltipItem = item;
        this.showTooltipFlag = true;

        // 计算提示框位置
        this.$nextTick(() => {
          const tooltip = this.$el.querySelector('.tooltip-box');
          if (tooltip) {
            const tooltipWidth = tooltip.offsetWidth;
            const tooltipHeight = tooltip.offsetHeight;
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            const mouseX = event.clientX;
            const mouseY = event.clientY;

            // 默认位置：鼠标右下方
            let left = mouseX + 10;
            let top = mouseY + 10;

            // 如果右侧空间不足，显示在左侧
            if (left + tooltipWidth > viewportWidth - 20) {
              left = mouseX - tooltipWidth - 10;
            }

            // 如果底部空间不足，显示在上方
            if (top + tooltipHeight > viewportHeight - 20) {
              top = mouseY - tooltipHeight - 10;
            }

            // 确保不超出左侧边界
            if (left < 10) {
              left = 10;
            }

            // 确保不超出顶部边界
            if (top < 10) {
              top = 10;
            }

            this.tooltipStyle = {
              top: top + 'px',
              left: left + 'px',
            };
          }
        });
      },

      // 隐藏悬浮提示
      hideTooltip() {
        this.showTooltipFlag = false;
        this.currentTooltipItem = null;
      },

      // 格式化数字显示
      formatTotalNum(num) {
        if (!num && num !== 0) return '-';

        // 如果是数字，格式化为带逗号的千分位
        if (typeof num === 'number') {
          return num.toLocaleString('zh-CN') + ' 万元';
        }

        // 如果是字符串，尝试转换为数字
        const number = parseFloat(num);
        if (!isNaN(number)) {
          return number.toLocaleString('zh-CN') + ' 万元';
        }

        return num;
      },

      getData() {
        this.chart = echarts.init(document.getElementById('pie3D-chart'));
        this.$api.screen
                .getEnterpriseRanking({
                  type: 4,
                  year: this.yearE,
                })
                .then(async (res) => {
                  let { data } = res.data;
                  if (data?.length) {
                    this.dataList = await data[0].rankings.map((item) => {
                      return {
                        ...item,
                        top: item.ranking,
                        companyName: item.enterpriseName,
                        city: item.comeFrom,
                        type: item.industry,
                        totalNum: item.totalNum || item.businessIncome || item.revenue, // 兼容不同字段名
                      };
                    });
                    this.scrollY = 0;
                    await this.scrollList();
                  }
                });

        // getTop100Data().then(res => {
        //   this.dataList = res.map(item => {
        //     return {
        //       top: item['排序'],
        //       companyName: item['企业名称'],
        //       city: item['地市'],
        //       type: item['所属行业']
        //     }
        //   });
        //   this.scrollY = 0;
        //   this.scrollList();
        // })

        // this.$nextTick(() => {
        //   this.chartOption = drawPie3D(this.chartData, 0, this.chart);
        // });
      },
      handleSizeChange(e) {
        this.pager.pageSize = e;
        this.getData();
      },
      handleCurrentChange(e) {
        this.pager.currentPage = e;
        this.getData();
      },
      scrollList() {
        let time = 0;
        let isBottom = false;
        if (this.scrollY && this.scrollY === this.listBox.scrollHeight) {
          isBottom = true;
          this.scrollY = this.listBox.scrollHeight;
        } else if (this.scrollY < this.listBox.scrollHeight) {
          isBottom = false;
        }
        let height = isBottom ? this.scrollY - this.listBox.scrollTop : this.scrollY - this.listBox.clientHeight;
        if (isBottom && this.listBox.scrollTop) {
          let top = this.listBox.scrollTop;
          let reTime = top && String(top).length > 4 ? 0.5 : 5;
          this.scrollY = 0;
          this.scrollList();
        } else {
          for (let i = height; i < this.scrollY; i++) {
            time++;
            setTimeout(() => {
              this.listBox.scrollTo(0, i);
            }, time * 10);
          }
        }
        if (!isBottom) {
          this.scrollY =
                  this.scrollY < this.listBox.scrollHeight ? this.scrollY + this.listBox.clientHeight : this.scrollY;
          this.scrollY =
                  this.scrollY > this.listBox.scrollHeight
                          ? this.listBox.scrollHeight
                          : this.scrollY === this.listBox.scrollHeight
                          ? 0
                          : this.scrollY;

          setTimeout(() => {
            this.scrollList();
          }, time + 10000);
        }
      },
    },
    mounted() {
      this.getData();

      this.$nextTick(() => {
        let listBox = $('.company-top-100 .table-list');
        this.listBox = listBox[0];
      });
    },
  };
</script>

<style lang="less" scoped>
  .company-top-100 {
    .chart-box();

    /deep/ .table-list {
      .table-item {
        cursor: pointer;
        padding: 0 20px;

        // 添加悬停效果
        &:hover {
          background-color: rgba(0, 0, 0, 0.05);
        }

        > div {
          .name {
            width: 180px;
            .ellipsis();
            flex: 1;
          }

          .city {
            min-width: 60px;
            max-width: 100px;
          }

          &.right {
            width: 110px;
            .flex-center();
            justify-content: flex-start;
            margin-left: 20px;

            .border-box {
              width: 100%;
            }
          }
        }
      }
    }

    /deep/.ele-dialog {
      &.company-profile .el-dialog {
        width: 2144px;
        height: 806px;
        .el-dialog__body {
          padding: 0;
          height: calc(100% - 55px);
        }
      }
    }

    /* 悬浮提示框样式 */
    .tooltip-box {
      position: fixed;
      z-index: 9999;
      background: rgba(0, 0, 0, 0.85);
      border-radius: 6px;
      padding: 12px 16px;
      color: #fff;
      font-size: 12px;
      line-height: 1.5;
      min-width: 240px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      border: 1px solid rgba(255, 255, 255, 0.1);
      pointer-events: none;
      animation: fadeIn 0.2s ease-out;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(5px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .tooltip-content {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    .tooltip-title {
      font-size: 14px;
      font-weight: 600;
      color: #fff;
      margin-bottom: 4px;
      padding-bottom: 4px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }

    .tooltip-row {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    .tooltip-label {
      color: rgba(255, 255, 255, 0.7);
      min-width: 70px;
      margin-right: 8px;
    }

    .tooltip-value {
      color: #fff;
      text-align: right;
      flex: 1;
      word-break: break-word;
    }
  }
</style>
